module.exports = __webpack_public_path__ + "img/usdt-intro.e6463fa4.png";